import { RECEIVE_NEW_EXPERIMENT_FLAGS } from 'stash/actions/experiments';

const experiments = (state={}, action) => {
  switch (action.type) {
    case RECEIVE_NEW_EXPERIMENT_FLAGS: {
      return {
        ...state,
        ...action.payload,
      }
    }
    default:
      return state;
  }
};

export default experiments;
